

import {
    Component,
    OnInit,
  } from "@angular/core";
import { FormBuilder, FormControl, FormGroup, Validators } from "@angular/forms";
  import { NGXLogger } from "ngx-logger";
  import { MenuItem, MessageService } from "primeng/api";
  
  import {
    DynamicDialogConfig,
    DynamicDialogRef,
  } from "primeng/dynamicdialog";
  import { Subject } from "rxjs";
import { PreventivoFase1DTO } from "src/app/models/dto/preventivoFase1.model";
import { SopralluogoFase1DTO } from "src/app/models/dto/sopralluogoFase1.model";
import { PraticaFlowdy2_Firestore } from "src/app/models/praticaFirestore.model";
import { GoogleStorageService } from "src/app/services/googleStorage.service";
import { PraticheScuolaService } from "src/app/services/pratiche.scuola.service";
import { PraticheService } from "src/app/services/pratiche.service";

  

@Component({
    selector: "app-rifiuta-preventivo-fase1",
    templateUrl: "./dialog-rifiuta-preventivo.component.html",
    styleUrls: ["../shared.component.css"],
  })
  export class DialogRifiutaPreventivoFase1 implements OnInit {
    protected _onDestroy = new Subject<void>();
    protected pratica: PraticaFlowdy2_Firestore;
    protected rifiutaPreventivoForm: FormGroup;
    protected isRifiutandoPreventivo:boolean = false;
    
    constructor(
      private logger: NGXLogger,
      public dialogRef: DynamicDialogRef,
      public config: DynamicDialogConfig,
      private googleStorageService: GoogleStorageService,
      private messageService: MessageService,
      private formBuilder: FormBuilder,
      private praticheService:PraticheService,
    ) {
      this.pratica          = this.config.data.pratica;
      this.rifiutaPreventivoForm = this.formBuilder.group({
        noteRifiutoPreventivo:        [ null, [Validators.required]]
      });
      
    }
  
    ngOnInit(): void {
    }

   

   
    conferma(conferma: boolean) {
      if (!conferma) {
        this.dialogRef.close({ success: false });
      } else {
        this.isRifiutandoPreventivo = true;
        let rifiutoPreventivo: PreventivoFase1DTO = new PreventivoFase1DTO();
            rifiutoPreventivo.note = this.rifiutaPreventivoForm.value.noteRifiutoPreventivo;
            this.praticheService
        
        
        
        this.praticheService.rifiutaPreventivo(this.pratica.id, rifiutoPreventivo).subscribe( {
            next: (res) => {
              this.isRifiutandoPreventivo = false;
              this.dialogRef.close({ success: true});
            },  error: (e) => {
              this.isRifiutandoPreventivo = false;
              this.messageService.add({
                severity: "info",
                summary: "Errore" , life:10000,
                  detail: "Errore in fase di rifiuto del preventivo!",
                });
              this.dialogRef.close({ success: false });
            },
            complete: () => {

            }
          }
        );
      
      } 
    }
  
  }